import { render, staticRenderFns } from "./CompanyInvoiceCard.vue?vue&type=template&id=6e8b185e&"
import script from "./CompanyInvoiceCard.vue?vue&type=script&lang=js&"
export * from "./CompanyInvoiceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports